import {DefaultInteraction} from "./interaction";

export class AnimateInteraction extends DefaultInteraction {

	animationName = "";

	constructor(animationName) {
		super();
		this.animationName = animationName
	}

	interact(target = this.entity) {
		if (target === null) {
			console.warn("No entity set for AnimateInteraction")
			return
		}

		console.log("AnimateInteraction", target, this.animationName)
		target.stopAllAnimations();
		target.playAnimation(this.animationName, false)
		return true
	}
}